import React, { useRef, useEffect, useState } from "react";
import { Viewer } from "@photo-sphere-viewer/core";
import "@photo-sphere-viewer/core/index.css";
import "@photo-sphere-viewer/gallery-plugin/index.css";

const PreviewImages = ({ image, index }) => {
  const instanceRef = useRef(null);
  const [view, setView] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!instanceRef.current) return;
    const viewer = new Viewer({
      container: instanceRef.current,
      loadingImg: "/logo192-round.png",
      panorama: "/blank.png",
      minFov: 30,
      maxFov: 120,
      navbar: null,
      defaultTransition: {
        rotation: false,
      },
    });

    setReady(true);
    setView(viewer);

    return () => viewer.destroy() && setReady(false);
  }, [instanceRef]);

  useEffect(() => {
    if (!ready) return;
    if (image?.constructor?.name === "Blob") {
      URL.revokeObjectURL(image);
    }
    const url = URL.createObjectURL(image);
    view.setPanorama(url, {
      transition: false,
      zoom: view.getZoomLevel() || 0,
      position: view.getPosition() || { yaw: 0, pitch: 0 },
    });
  }, [view, ready, image, index]);

  return (
    <div
      ref={instanceRef}
      style={{
        width: "100%",
        height: "800px",
        maxHeight: "800px",
      }}
    />
  );
};

export default PreviewImages;
